import BehaviorConfig from '@/models/app-config/behavior/behavior'
import {
  defaultSignUpFormParts,
  fitowaSignupFormParts,
  mycolorSignUpFormParts,
  SignUpFormParts,
  vilbSignUpFormParts,
} from './form-parts'

export function createSignUpFormParts(behavior: BehaviorConfig): SignUpFormParts {
  if (behavior.isVilb) return vilbSignUpFormParts(behavior)

  if (behavior.isFitowa) return fitowaSignupFormParts(behavior)

  if (behavior.isMyColor) return mycolorSignUpFormParts(behavior)

  return defaultSignUpFormParts()(behavior)
}
